module.exports = __webpack_public_path__ + "img/planito2.38a5ae6b.png";